import { PRICE_SOURCE } from 'types/active'
import { CardType, OWNED } from 'types/deck'

import { store } from 'redux/store'

import { getPrice } from 'utils/Price'

export type Options = {
  header: boolean
  quantity: boolean
  name: boolean
  edition: boolean
  editionCode: boolean
  category: boolean
  secondaryCategories: boolean
  label: boolean
  price: boolean
  collection: boolean
  modifier: boolean
  collectorNumber: boolean
  salt: boolean
  color: boolean
  cmc: boolean
  rarity: boolean
  scryfallId: boolean
  types: boolean
  cardText: boolean
}

export function buildCsvFile(cards: Array<CardType>, options: Options): string {
  const {
    quantity,
    name,
    edition,
    editionCode,
    category,
    secondaryCategories,
    label,
    price,
    collection,
    modifier,
    collectorNumber,
    salt,
    color,
    cmc,
    rarity,
    scryfallId,
    types,
    cardText,
  } = options

  let header = ''

  if (quantity) header += 'quantity,'
  if (name) header += 'card name,'
  if (edition) header += 'edition name,'
  if (editionCode) header += 'edition code,'
  if (category) header += 'category,'
  if (secondaryCategories) header += 'secondary categories,'
  if (label) header += 'label,'
  if (modifier) header += 'modifier,'
  if (collectorNumber) header += 'collector number,'
  if (salt) header += 'salt,'
  if (color) header += 'color,'
  if (cmc) header += 'cmc,'
  if (rarity) header += 'rarity,'
  if (scryfallId) header += 'scryfall ID,'
  if (types) header += 'types,'
  if (price) header += 'price,'
  if (collection) header += 'collection status,'
  if (cardText) header += 'card text,'

  if (header.charAt(header.length - 1) === ',') header = header.substring(0, header.length - 1)

  header += '\n'

  const fileBody = cards.reduce((output, card) => {
    const cardTypes = card.front && card.back ? [...card.front.types, ...card.back.types] : card.types

    if (quantity) output += card.qty + ','
    if (name) output += (card.name.includes(',') ? '"' + card.name + '"' : card.name) + ','
    if (edition) output += (card.set.includes(',') ? '"' + card.set + '"' : card.set) + ','
    if (editionCode) output += card.setCode + ','
    if (category) output += card.categories[0] + ','
    if (secondaryCategories) output += `"${card.categories.filter((_c, i) => i > 0).join(',')}",`
    if (label) output += (card.colorLabel.name === '' ? 'default' : card.colorLabel.name) + ','
    if (modifier) output += `${card.modifier},`
    if (collectorNumber) output += `${card.collectorNumber},`
    if (salt) output += `${card.salt},`
    if (color) output += `"${card.colors.join(',')}",`
    if (cmc) output += `${card.cmc},`
    if (rarity) output += `${card.rarity},`
    if (scryfallId) output += `${card.uid},`
    if (types) output += `"${cardTypes.join(',')}",`

    if (price) {
      const state = store.getState()
      const priceSource = state ? state.active.priceSource[0] : PRICE_SOURCE.TCG
      const { price } = getPrice(card, priceSource, card.modifier !== 'Normal')

      output += `${price},`
    }

    if (collection) {
      if (card.owned === OWNED.NO) output += 'not owned,'
      else if (card.owned === OWNED.YES) output += 'own exact edition,'
      else output += 'own different edition,'
    }

    if (cardText) {
      const rawText = card.text || `${card?.front?.text} // ${card?.back?.text}`

      // @ts-ignore
      const cardText = rawText.replaceAll('"', '""').replaceAll('\n', ' ')

      output += `"${cardText}"`
    }

    if (output.charAt(output.length - 1) === ',') {
      output = output.substring(0, output.length - 1)
    }

    output += '\n'

    return output
  }, '')

  if (options.header) return header + fileBody

  return fileBody
}
